import { useEffect } from 'react';
import PropTypes from 'prop-types';
const UIM_SDK_ENV = process.env.REACT_APP_UIM_SDK_ENV;
const RB_ACCOUNT_SUBDOMAIN =
  UIM_SDK_ENV === 'design' ? 'stage-account' : 'account';

const GlobalNav = ({ country, language }) => {
  const navProps = {
    locale: `${country.toLowerCase()}-${language}`,
    opaque: 'true',
  };
  // Override Logo URL
  const logoURL = () => {
    const logo = document.getElementsByClassName('rb3-menu-header__logo')[0];
    if (logo) logo.href = 'https://www.redbull.com';
  };

  // Global Navigation Script
  useEffect(() => {
    // Set global vars to enable environment-specific sdk
    // RBGEMC_ACCOUNTS_ENV sets dropdown urls, RBGEMC_ACCOUNTS_BUNDLE sets sdk src path
    window.RBGEMC_ACCOUNTS_ENV = UIM_SDK_ENV;
    window.RBGEMC_ACCOUNTS_BUNDLE = `https://${RB_ACCOUNT_SUBDOMAIN}.redbull.com/sdk/rba-lightbox.min.js`;
    const navScript = document.createElement('script');
    navScript.src = 'https://www.redbull.com/v3/widgets/menu.js';
    navScript.defer = true;
    navScript.onload = logoURL;
    document.getElementById('rb3-global-menu').appendChild(navScript);
  }, []);

  return (
    <div id="rb3-global-menu">
      <div id="rb3-global-menu__wrapper" className="rb3-global-menu__wrapper">
        <script
          dangerouslySetInnerHTML={{ __html: JSON.stringify(navProps) }}
          type="text/props"
        ></script>
        <div style={{ height: '80px', backgroundColor: '#001e3c' }} />
      </div>
    </div>
  );
};

GlobalNav.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default GlobalNav;
